// File: app/constants/images.js

export default {
  logoFull: require('../../assets/jobeng_full_logo.png'),
  logoTransparent: require('../../assets/jobeng_logo_transparent.png'),
};
